import React from 'react';
import { st, classes } from './NoAvailableSlots.st.css';
import { AccessibilityHtmlTags } from '../../../../utils/accessibility/constants';
import {
  Text,
  SectionNotificationType as NOTIFICATION_TYPE,
  SectionNotification,
} from 'wix-ui-tpa';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { NoAvailableSlotsViewModel } from '../../ViewModel/noAvailableSlotsViewModel/noAvailableSlotsViewModel';
import { DataHooks } from './constants';
import { useCalendarActions } from '../../Hooks/useCalendarActions';
import { ReactComponent as AlertIcon } from '../../../../assets/Icons/notificationAlert.svg';
import { Button } from '../Button/Button';

export type NoAvailableSlotsProps = {
  viewModel: NoAvailableSlotsViewModel;
};

const NoAvailableSlots: React.FC<NoAvailableSlotsProps> = ({ viewModel }) => {
  const { goToNextAvailableDate } = useCalendarActions();
  const { isMobile } = useEnvironment();

  const {
    noSessionsOfferedText,
    noUpcomingTimeSlotsText,
    checkAvailabilityCTA,
  } = viewModel;

  return (
    <div
      className={st(classes.root, { isMobile })}
      data-hook={DataHooks.NoAvailableSlots}
    >
      <Text
        data-hook={DataHooks.Text}
        className={st(classes.noAvailableSlots)}
        tagName={AccessibilityHtmlTags.Paragraph}
      >
        {noSessionsOfferedText}
      </Text>
      {checkAvailabilityCTA ? (
        <Button
          data-hook={DataHooks.CTA}
          onClick={() => goToNextAvailableDate()}
          fullWidth={checkAvailabilityCTA.isFullWidth}
        >
          {checkAvailabilityCTA.text}
        </Button>
      ) : null}
      {noUpcomingTimeSlotsText ? (
        <SectionNotification
          className={classes.notification}
          data-hook={DataHooks.Notification}
          type={NOTIFICATION_TYPE.alert}
        >
          <SectionNotification.Icon icon={<AlertIcon />} />
          <SectionNotification.Text>
            {noUpcomingTimeSlotsText}
          </SectionNotification.Text>
        </SectionNotification>
      ) : null}
    </div>
  );
};

export default NoAvailableSlots;
